import { RaroBrand } from '@raro/ui';
import { Link, useParams } from 'react-router';
import { ReviewWorkspace } from '../components/review/ReviewWorkspace';

/** Revisão pelo cliente, dentro da sala: marca o que quiser e decide. Nunca vê o que é interno. */
export function ClientRevisaoPage() {
  const { slug = '', id = '' } = useParams();
  return (
    <div className="rr-client-review">
      <div className="rr-client-review__top"><Link to={`/client/${slug}?v=make`}><RaroBrand /></Link></div>
      <ReviewWorkspace deliverableId={id} backHref={`/client/${slug}?v=make`} backLabel="← sala" />
    </div>
  );
}
